import React from 'react';
import { List, ListItem, ListItemText, Divider, Typography, CircularProgress, Box } from '@mui/material';

const CommentList = ({ comments = [], loading }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={20} />
        <Typography variant="body2">Loading comments…</Typography>
      </Box>
    );
  }

  if (!comments.length) {
    return <Typography variant="body2" color="text.secondary">Be the first to share your thoughts.</Typography>;
  }

  return (
    <List>
      {comments.map((comment, index) => (
        <React.Fragment key={comment.id || index}>
          <ListItem alignItems="flex-start">
            <ListItemText
              primary={comment.displayName || comment.user || 'Guest'}
              secondary={comment.text}
            />
          </ListItem>
          {index < comments.length - 1 && <Divider variant="inset" component="li" />}
        </React.Fragment>
      ))}
    </List>
  );
};
export default CommentList;
